"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IfAnonymousUser = void 0;
var _useToken = require("./useToken");
var IfAnonymousUser = function(param) {
    var children = param.children;
    var isAnonymousUser = (0, _useToken.useToken)().isAnonymousUser;
    if (isAnonymousUser) {
        return children;
    }
    return null;
};
exports.IfAnonymousUser = IfAnonymousUser; //# sourceMappingURL=IfAnonymousUser.js.map
